export default "__VITE_ASSET__7UYGLJPF__"